export default __webpack_public_path__ + "static/media/pepper-alert-circle.1003d8e9.svg";